(function() {
	'use strict';

	if(document.querySelector('body.neos-backend')) {
		return;
	}

	var telLinks = document.querySelectorAll('a[href^="tel"]');
	for(var i=0; i<telLinks.length; i++) {
		telLinks[i].addEventListener('click', function(event) {
			ga('send', {
				hitType: 'event',
				eventCategory: 'Interaktion',
				eventAction: 'Klick Telefonnummer',
				eventLabel: ((window.location || {}).href || '').indexOf('unsere-leistungen') ? 'Leistungsseite Call2Action' : 'Allgemein'
			});
			console.info('Klick auf Tel');
		});
	};

	var emailLinks = document.querySelectorAll('a[href^="mail"]');
	for(var i=0; i<emailLinks.length; i++) {
		emailLinks[i].addEventListener('click', function(event) {
			ga('send', {
				hitType: 'event',
				eventCategory: 'Interaktion',
				eventAction: 'Klick auf E-Mail',
				eventLabel: ((window.location || {}).href || '').indexOf('unsere-leistungen') ? 'Leistungsseite Call2Action' : 'Allgemein'
			});
			console.info('Klick auf E-Mail');
		});
	};


	var contactInput = document.querySelectorAll('#contact input');
	for(var i=0; i<contactInput.length; i++) {
		contactInput[i].addEventListener('click', function(event) {
			ga('send', {
				hitType: 'event',
				eventCategory: 'Formular',
				eventAction: 'Start Eingabe Kontaktformular',
				eventLabel: ''
			});
			console.info('Start Eingabe Kontaktformular');
		});
	};

	var contactButton = document.querySelector('#contact .btn');
	if(contactButton) {
		contactButton.addEventListener('click', function(event) {
			ga('send', {
				hitType: 'event',
				eventCategory: 'Formular',
				eventAction: 'Klick auf Abschicken-Button',
				eventLabel: ''
			});
			console.info('Klick auf Abschicken-Button');
		});
	}

}());
